






































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  CUSTOMER_MARITAL_STATUS_LABELS,
  CUSTOMER_SALUTATION_LABELS,
  CUSTOMER_STATUS_LABELS,
  CUSTOMER_TITLE_OPTIONS,
  CUSTOMER_TYPE_LABELS,
  CustomerGender,
  CustomerMaritalStatus,
  CustomerSalutation,
  CustomerTitle,
  CustomerStatus,
  CustomerType,
  ITag,
  TagCategory,
  IUser,
} from 'admiral-core';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormDateInput from '@/components/common/forms/FormDateInput.vue';
import FormRow from '@/components/common/forms/FormRow.vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';

export type CustomerFormModel = {
  id?: string;
  type: CustomerType;
  status: CustomerStatus;
  email?: string;
  name?: string;
  salutation?: CustomerSalutation;
  firstname?: string;
  lastname?: string;
  additionalName?: string;
  title?: CustomerTitle;
  gender?: CustomerGender;
  maritalStatus?: CustomerMaritalStatus;
  profession?: string;
  street?: string;
  zip?: string;
  city?: string;
  addressSupplement?: string;
  phoneLandline?: string;
  phoneMobile?: string;
  identifier?: string;
  birthDate?: Date;
  contactPerson?: string;
  user?: IUser;
  tags?: ITag[];
};

@Component({
  components: { FormInput, FormDateInput, FormRow, TagSelect, UserSelect },
})
export default class CustomerForm extends Vue {
  CustomerType = CustomerType;
  CustomerStatus = CustomerStatus;

  /** Status-Optionen für das Dropdown (Aktiv, Inaktiv, Archiviert). */
  get customerStatusOptions(): { value: CustomerStatus; label: string }[] {
    return Object.values(CustomerStatus).map((value) => ({
      value,
      label: CUSTOMER_STATUS_LABELS[value],
    }));
  }
  CustomerGender = CustomerGender;
  CustomerSalutation = CustomerSalutation;
  CustomerMaritalStatus = CustomerMaritalStatus;
  CustomerTitle = CustomerTitle;
  customerTypeLabels = CUSTOMER_TYPE_LABELS;
  customerSalutationLabels = CUSTOMER_SALUTATION_LABELS;
  customerMaritalStatusLabels = CUSTOMER_MARITAL_STATUS_LABELS;
  titleOptions = CUSTOMER_TITLE_OPTIONS;
  @Prop({ required: true })
  value!: CustomerFormModel;

  @Prop({ default: () => ({}) })
  errors!: Record<string, boolean>;

  get TAG_CATEGORY_CUSTOMERS() {
    return TagCategory.Customers;
  }

  onInput(field: keyof CustomerFormModel, val: any) {
    const next = { ...this.value, [field]: val };
    if (field === 'type') {
      if (val === CustomerType.LEGAL) {
        next.birthDate = undefined;
        next.salutation = undefined;
        next.additionalName = undefined;
        next.gender = undefined;
        next.profession = undefined;
        next.maritalStatus = undefined;
        next.title = undefined;
      } else {
        next.contactPerson = undefined;
      }
    }
    this.$emit('input', next);
  }

  /** Setzt den zuständigen Mitarbeiter. */
  onUserInput(user: IUser | IUser[] | undefined) {
    const resolved = Array.isArray(user) ? user[0] : user;
    const nextUser = resolved?.id ? resolved : undefined;
    this.$emit('input', { ...this.value, user: nextUser });
  }

  /** Setzt Titel (leer = undefined). */
  onTitleInput(event: Event) {
    const raw = (event.target as HTMLSelectElement).value;
    const title = raw ? (raw as CustomerTitle) : undefined;
    this.$emit('input', { ...this.value, title });
  }

  /** Setzt Anrede (leer = undefined). */
  onSalutationInput(event: Event) {
    const raw = (event.target as HTMLSelectElement).value;
    const salutation = raw ? (raw as CustomerSalutation) : undefined;
    this.$emit('input', { ...this.value, salutation });
  }

  /** Setzt Geschlecht (leer = undefined). */
  onGenderInput(event: Event) {
    const raw = (event.target as HTMLSelectElement).value;
    const gender = raw ? (raw as CustomerGender) : undefined;
    this.$emit('input', { ...this.value, gender });
  }

  /** Setzt Familienstand (leer = undefined). */
  onMaritalStatusInput(event: Event) {
    const raw = (event.target as HTMLSelectElement).value;
    const maritalStatus = raw ? (raw as CustomerMaritalStatus) : undefined;
    this.$emit('input', { ...this.value, maritalStatus });
  }

  /** Setzt Geburtsdatum aus dem Datums-Picker (optional). */
  onBirthDateInput(birthDate: Date | undefined) {
    this.$emit('input', { ...this.value, birthDate });
  }
}
